import { Component, HostListener, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FuelcardService } from '../../vdms_core/services/api/fuelcard.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AwsService } from '../../../../providers/appsyncservice/aws.service';

@Component({
  selector: 'app-assign-fuel-card',
  templateUrl: './assign-fuel-card.component.html',
  styleUrls: ['./assign-fuel-card.component.css']
})
export class AssignFuelCardComponent implements OnInit {

  helperunassignCardData: any = [];
  unassignCardData: any = [];
  fuelCardsearchInput: FormControl = new FormControl();
  isFuelCardDropdownVisible: boolean = false;
  allAssignCarData: any = [];
  helperUserData: any = [];
  userData: any = [];
  helperVehicleData: any = [];
  vehicleData: any = [];

  assignFuelCardForm: FormGroup;
  searchRnNumberInput: FormControl = new FormControl();
  isRnDropdownVisible: boolean = false;

  constructor(
    public awserviceProvider: AwsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fuelCardService: FuelcardService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.assignFuelCardForm = new FormGroup({
      rn_number: new FormControl('', Validators.required),
      rn_no: new FormControl('', Validators.required),
      vehicle_reg_id: new FormControl('', Validators.required),
      assigned_car_id: new FormControl('', Validators.required),
      fuel_card_number: new FormControl('', Validators.required),
      fuel_card_id: new FormControl('', Validators.required),
    });
    this.getAssignCarData();
  }

  getAssignCarData() {
    this.fuelCardService.getAssignCarData().then((res: any) => {
      let allData = res;
      this.allAssignCarData = allData.map((item: any) => {
        if(item.car.ex_data == "ASSIGN" && (!item.fuel_card_id || item.fuel_card_id === "" || item.fuel_card_id === null)) {
          return {
            ...item,
            car_id: item.car.id,
            veh_reg_id: item.car.veh_reg_id,
            ex_data: item.car.ex_data
          }
        }
      });
      this.allAssignCarData = this.allAssignCarData.filter((item: any) => item !== undefined);
      this.helperUserData = Array.from(new Set(this.allAssignCarData.map((item: any) => ({user_pid: item.user_pid, rn_id: item.rn_id}))));
      this.userData = JSON.parse(JSON.stringify(this.helperUserData));
      console.log("userData:", this.helperUserData, this.allAssignCarData);
      this.getAllFuelCard();
    }).catch((error) => {
      console.error("Error fetching assign car data:", error);
    });
  }

  async getAllFuelCard() {
    const limit = 100;  // Set the limit for records per request
    let nextToken: any = null;  // Start with null for the first page
    this.unassignCardData = []// Initialize tempData to store fetched data
    this.spinnerService.show();  // Show spinner while loading data

    try {
      const data = (await this.fuelCardService.getAllAssignFuelCardMaster());
        console.log("Fetched Page Data:", data);

      this.helperunassignCardData = [...this.helperunassignCardData, ...data];
      this.unassignCardData = JSON.parse(JSON.stringify(this.helperunassignCardData));

      console.log("All records fetched:", typeof this.unassignCardData, this.unassignCardData);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();  // Hide the spinner after the process
    }
  }

  navigateToFuelCardDetails() {
    this.router.navigate(['pages/fuel-card-details']);
  }

  toggleDropdown(type: number) {
  if (type == 1) {
    this.isRnDropdownVisible = !this.isRnDropdownVisible;
  } else if (type == 2) {
    this.isFuelCardDropdownVisible = !this.isFuelCardDropdownVisible;
  }
  }

  searchRnNumber(value: string){
    let rnData = JSON.parse(JSON.stringify(this.helperUserData));
    this.userData = rnData.filter((rn: any) => rn.rn_id.toLowerCase().includes(value.toLowerCase()));
  }

  searchFuelCard(value: any) {
    let cardData = JSON.parse(JSON.stringify(this.helperunassignCardData));
    this.unassignCardData = cardData.filter((card: any) => String(card.card_number).toLowerCase().includes(value.toLowerCase()));
  }

  setRnNumber(id: any, rn) {
    this.assignFuelCardForm.patchValue({
      rn_number: id,
      rn_no: rn,
      vehicle_reg_id: '',
      assigned_car_id: '',
    });
    this.isRnDropdownVisible = false;
    this.helperVehicleData = this.allAssignCarData.filter((item: any) => item.rn_id === rn);
    this.vehicleData = JSON.parse(JSON.stringify(this.helperVehicleData));
    console.log(this.vehicleData, "this.vehicleData");
    
  }

  setAssignedCarId(id: any) {
    const vehicle = this.vehicleData.find((item: any) => String(item.car_id) === String(id));
    console.log(vehicle, "vehicle", id);
    this.assignFuelCardForm.patchValue({
      assigned_car_id: vehicle.id,
    });
  }

  setFuelCardValue(id: any, card_number: any) {
    this.assignFuelCardForm.patchValue({
      fuel_card_id: id,
      fuel_card_number: card_number
    });
    this.isFuelCardDropdownVisible = false;
  }


  @HostListener('document:click', ['$event'])
  closeDropdown(event: MouseEvent) {
    // Check if the clicked element is inside any of the dropdowns
    const clickedInsideSelect = event.target && event.target['closest']('.cus-select-container');
    const clickedInsideFuelCardSelect = event.target && event.target['closest']('.cus-fuel-select-container');

    // Handle the first dropdown (cus-select-container)
    if (!clickedInsideSelect && this.isRnDropdownVisible) {
      this.isRnDropdownVisible = false;
      this.userData = JSON.parse(JSON.stringify(this.helperUserData));
      this.searchRnNumberInput.setValue('');
    }

    // Handle the second dropdown (cus-fuel-select-container)
    if (!clickedInsideFuelCardSelect && this.isFuelCardDropdownVisible) {
      this.isFuelCardDropdownVisible = false;
      this.unassignCardData = JSON.parse(JSON.stringify(this.helperunassignCardData));
      this.fuelCardsearchInput.setValue('');
    }
  }


  onSubmit() {
    if(this.assignFuelCardForm.valid) {
      let formData = this.assignFuelCardForm.value;
      console.log("Form Data to Submit:", formData);
      this.spinnerService.show();
      let payload = {
        fuel_card_id: formData.fuel_card_id,
        id: formData.assigned_car_id
      };
      this.fuelCardService.assignFuelCardToCar(payload).then((res) => {
        console.log("Fuel Card Assigned Successfully:", res);
        this.updateFuelCardStatus(formData.fuel_card_id);
      }).catch((error) => {
        console.error("Error Assigning Fuel Card:", error);
        this.spinnerService.hide();
      });
    } else {
      console.log("Form Value Is Invalid");
    }
  }

  updateFuelCardStatus(fuel_card_id: any) {
    let payload = {
      fuel_card_id: fuel_card_id,
      status: "ASSIGN"
    };
    this.awserviceProvider
      .updateFuelCardStatus(payload)
      .then((result) => {
        this.spinnerService.hide();
        console.log("updateFuelCardMaster", result);
        this.navigateToFuelCardDetails();
      })
      .catch((err) => {
        this.spinnerService.hide();
        console.log("err", err);
      });
  }

}
